import { buildModuleApi } from "./_ApiUtil/_buildModuleApi";

const { API, PERMISSIONS, CONSTANTS, ENDPOINTS } = buildModuleApi({
    prefix: "CONFIG", uri: "config", withExtra: false,

    exclude: [
        "LIST", "CREATE", "UPDATE", "REMOVE", "DETAIL",
        "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE", "BULK_RESTORE",
        "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM",
    ],

    extraActions: {
        SETTINGS: { suffix: "/settings", permission: null },
        TRANSLATIONS: { suffix: "/translations", permission: null },
    },
});

export const CONFIG_API = API;
export const CONFIG_ENDPOINTS = ENDPOINTS;
export const CONFIG_CONSTANTS = CONSTANTS;
export const CONFIG_PERMISSIONS = PERMISSIONS;
